import { render } from "./SurveyManager.vue?vue&type=template&id=b858ad2c&scoped=true"
import script from "./SurveyManager.vue?vue&type=script&lang=js"
export * from "./SurveyManager.vue?vue&type=script&lang=js"

import "./SurveyManager.vue?vue&type=style&index=0&id=b858ad2c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b858ad2c"]])

export default __exports__